import React from 'react';
import './PC.css';
import Almog from '../../img/pc/Almog.png'
import Bais from '../../img/pc/Bais.png'
import Benz from '../../img/pc/Benz.png'
import debugagent from '../../img/pc/debugagent.png'
import Derks from '../../img/pc/Derks.png'
import Engelbert from '../../img/pc/Engelbert.png'
import goldsmiths from '../../img/pc/goldsmiths.png'
import Google from '../../img/pc/Google.png'
import INGBankNetherlands from '../../img/pc/INGBankNetherlands.png'
import Joshi from '../../img/pc/Joshi.png'
import Microsoft from '../../img/pc/Microsoft.png'
import Palsenberg from '../../img/pc/Palsenberg.png'
import Santana from '../../img/pc/Santana.png'
import Shen from '../../img/pc/Shen.png'
import TeamRockstarsIT from '../../img/pc/TeamRockstarsIT.png'
import Timescale from '../../img/pc/Timescale.png'
import Zup from '../../img/pc/Zup.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      speakers: [
        {
          photo: Shen,
          name: 'Xiang Shen',
          position: 'Solutions Architect',
          logo: Google,
        },
        {
          photo: Benz,
          name: 'Brian Benz',
          position: 'Cloud Advocate',
          logo: Microsoft,
          ln: 'https://www.linkedin.com/in/brianbenz',
          tw: 'https://twitter.com/bbenz',
        },
        {
          photo: Engelbert,
          name: 'Christoph Engelbert',
          position: 'Senior Developer Advocate',
          logo: Timescale,
          ln: 'https://www.linkedin.com/in/noctarius/',
          tw: 'https://twitter.com/noctarius2k',
          github: 'https://github.com/noctarius',
        },
        {
          photo: Palsenberg,
          name: 'Igmar Palsenberg',
          position: 'Platform architect',
          logo: INGBankNetherlands,
          tw: 'https://twitter.com/palsenberg',
        },
        {
          photo: Santana,
          name: 'Otavio Santana',
          position: 'Distinguished Software Engineer',
          logo: Zup,
          ln: 'https://www.linkedin.com/in/otaviojava/',
          tw: 'https://twitter.com/otaviojava',
          github: 'https://github.com/otaviojava',
        },
        {
          photo: Bais,
          name: 'Teo Bais',
          position: 'JUG Founder & Leader at Utrecht Java User Group',
          ln: 'https://www.linkedin.com/in/teobais/',
        },
        {
          photo: Almog,
          name: 'Shai Almog',
          position: 'Developer Advocate',
          logo: debugagent,
          ln: 'https://www.linkedin.com/in/shai-almog-81a42/',
        },
        {
          photo: Joshi,
          name: 'Suyash Joshi',
          position: 'Creative Technologist',
          logo: goldsmiths,
          tw: 'https://twitter.com/suyashcjoshi',
        },
        {
          photo: Derks,
          name: 'Edwin Derks',
          position: 'Principal Consultant',
          logo: TeamRockstarsIT,
          ln: 'https://www.linkedin.com/in/edwin-derks/',
          tw: 'https://twitter.com/edwinderks',
          github: 'https://github.com/ederks85',
        },
      ],
    }
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className='pc_info' style={{ backgroundImage: `url(${item.photo}` }}>
          <p className="pc_name p1">{item.name}</p>
          <p className="pc_position p2 grey">{item.position}</p>
          <img className='pc_logo' src={item.logo} alt="" />
          <div className="pc_links">
            {item.fb && <a className="social_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="social_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="social_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="social_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="social_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="social_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
            {item.twitch && <a className="social_link social_twitch" target='_blank' rel="noreferrer" href={item.twitch}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc_wrap pc_wrap--mb" id='pcc'>
        <div className='container pc'>
          <h2 className='pc_title pc_main'>Program <span className='title_gradient'>committee</span></h2>
          <div className='pc_block'>
            {this.state.speakers.map((item, i) => this.renderPC(item, i))}
          </div>
        </div>
      </div>
    )
  }
}